/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { closeModal } from '../../../utils/modal-helpers';
window.ParticipantsCompanies = {

  _initializeInviteByEmail() {
    $(document).on('click', '#invite-by-email-button', e => {
      e.preventDefault();
      this.parsleyForm.reset();
      $('#invite-by-email-form small.error').remove();
      $('#invite-by-email-form .error').removeClass('error');
      $('#invite-by-email-form input').val('');
      $('#invite-by-email-content').html('');
      return $('#invite-by-email').foundation('reveal', 'open');
    });

    $(document).on('ajax:success', '#invite-by-email-form', (e, response) => {
      this.company = response;
      if (this.company.exists) {
        $('#invite-by-email-content').html(this._inviteByEmailTemplate(this.company));
        return $(document).foundation({
          tooltip: {
            selector: '.has-tip'
          }
        });
      } else {
        $('#invite-by-email-content').html('');
        $("#selected-company-colleague-list").append(this.selectedByEmailTemplate(this.company));
        return closeModal('invite-by-email');
      }
    });

    $(document).on('click', '#invite-exists-company', () => {
      $("#selected-company-colleague-list").append(this.selectedTemplate(this.company));
      return closeModal('invite-by-email');
    });

    return $(document).on('click', '#cancel-invite', () => {
      return closeModal('invite-by-email');
    });
  },

  _inviteByEmailTemplate: _.template(`<tr id='inviteByEmail<%= id %>'>
<td style='width: 40px'>
<a id='cancel-invite'><i class='pti pt-close'></i></a>
</td>
<td>
<span class='has-tip' title='<%= title %>' data-tooltip><%= name %></span>
<div class='right'>
<a id='invite-exists-company' class='button btn-icon pt-add nano'></a>
</div>
</td>
</tr>`),

  _initializeValidations() {
    return this.parsleyForm = $('#invite-by-email-form').parsley();
  },

  _initializeDeadlines() {
    return $(document).on('click', '#invite-companies-form :radio', e => $('#due-date-calendar').toggleClass('hide', !_.contains(['documenter', 'verifier'], $(e.target).val())));
  },

  initialize() {
    this._initializeInviteByEmail();
    this._initializeValidations();
    return this._initializeDeadlines();
  },

  selectedByEmailTemplate: _.template(`<tr id='selectedCompaniesColleagues<%= id %>'>
<td>
<div class='right'>
<a href='#' class='remove-company-colleague' data-id='<%= id %>'><i class='pti pt-close'></i></a>
</div>
<p>
<i class='pti pt-building'></i>
<%= title %>
</p>
<input id='invitation_new_companies' name='invitation[new_companies][companies][][name]' type='hidden' value='<%= name %>'>
<input id='invitation_new_companies' name='invitation[new_companies][companies][][email]' type='hidden' value='<%= email %>'>
</td>
</tr>`),

  selectedTemplate: _.template(`<tr id='selectedCompaniesColleagues<%= id %>'>
<td>
<div class='right'>
<a href='#' class='remove-company-colleague' data-id='<%= id %>'><i class='pti pt-close'></i></a>
</div>
<p>
<i class='pti pt-building'></i>
<%= name %>
</p>
<input name='invitation[company_invitations_attributes][<%= id %>][company_id]'
type='hidden' value='<%= id %>' />
</td>
</tr>`),

  participantType: 'company'
};
